<template>
  <div class="theme">
    <el-tooltip :content="theme" effect="dark" placement="bottom">
      <div class="btn-icon" @click="toMap">
        <svg-icon :style="{color: $store.state.theme.activeName==='block'? '#b1d3fb': '#606266',}" icon-class="icon-maps" class="svg-map" style="font-size:20px!important;" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    params: String
  },
  data() {
    return {}
  },
  computed: {
    theme() {
      return this._i18n.tc('navbar.screenfull')
    }
  },
  methods: {
    toMap() {
      const url = '/Map/index.html#' + (this.params || '')
      window.open(url,'_blank','noopener')
    }
  }
}
</script>
<style lang="scss">
</style>

